import { Box } from '@mui/material';
import React from 'react';

import { WIDTH_MODAL_COMPONENTS } from '../../../../../constants/addressBook';

interface IProps {
  children: React.ReactNode;
}

const CenteredAlertWrapper: React.FC<IProps> = ({ children }) => {
  return (
    <Box
      sx={{
        maxWidth: WIDTH_MODAL_COMPONENTS,
        mx: 'auto',
        minHeight: 200,
        height: '100%',
        maxHeight: 437,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        py: 4,
      }}
    >
      {children}
    </Box>
  );
};

export default CenteredAlertWrapper;
